module.exports = __webpack_public_path__ + "static/media/close.abbc49fc.svg";